const prefixer="https://api.pkf-autonomio.de/api/v1/"
// const prefixer="http://localhost:5028/api/v1/"

export const AuthUrls = {
    LOGIN_USER : `${prefixer}auth/login/admin`,
    UPDATE_PASSWORD: `${prefixer}user/update-password`,
    CHECK_TOKEN: `${prefixer}auth/login/check-token`,
    DEFAULT_DATA: `${prefixer}users/default/data`,
    ADD_NEW_USER: `${prefixer}users/new`,
    READ_ALL_USERS: `${prefixer}users`,
    READ_ALL_LICENSES: `${prefixer}licensing`,
    GENERATE_NEW_LICENSE: `${prefixer}licensing/generate_key`,
    DELETE_LICENSE: `${prefixer}licensing`,
    UPDATE_LICENSE: `${prefixer}licensing`,
    DELETE_USER: `${prefixer}users`,
    UPDATE_USER: `${prefixer}users`,
    LICENSE_USAGE_DATA: `${prefixer}licensing/license_usage`,
    STATS: `${prefixer}user-usage/stats`,
    AUTH_ME: `${prefixer}auth/me`,
    LATEST_VERSION: `${prefixer}storages/latest-version`,
    UPLOAD_NEW_VERSION: `${prefixer}storages/file/raw`
}